/* @nav.js  */

// Function for toggling nav
(function () {
  'use strict';
  var triplebar, menu;
  document.addEventListener('DOMContentLoaded', function (e) {
    triplebar = document.querySelector('.triplebar');
    menu = document.querySelector('.menu');
    triplebar.addEventListener('click', function () {
      if (menu.className === 'menu') {
        menu.className = 'menu max';
      } else {
        menu.className = 'menu';
      }
    });
    document.addEventListener('click', function (e) {
      var classes = e.target.className;
      if (classes === 'menu-item') {
        menu.className = 'menu';
      }
    });
  });
}());